import React from 'react'

function Essential() {
  return (
    <div> <svg
    width="16"
    height="17"
    viewBox="0 0 16 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M9.68421 6.58008H7.64887C7.19354 6.58008 6.87221 6.13408 7.01621 5.70274V5.70274C7.23954 5.03208 7.86687 4.58008 8.57354 4.58008H8.75887C9.46554 4.58008 10.0929 5.03208 10.3162 5.70274V5.70274C10.4602 6.13408 10.1389 6.58008 9.68421 6.58008V6.58008Z"
      stroke="#959595"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M4.66218 9.3418H2.66684C2.25751 9.3418 1.94484 9.70713 2.00818 10.1111L2.23751 11.5778C2.44018 12.8765 3.55818 13.8331 4.87218 13.8331H11.1282C12.4422 13.8331 13.5602 12.8765 13.7628 11.5785L13.9922 10.1118C14.0555 9.7078 13.7428 9.34246 13.3335 9.34246H8.17551"
      stroke="#959595"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M8.66699 4.58V4.5C8.66699 3.39533 9.56233 2.5 10.667 2.5V2.5C11.7717 2.5 12.667 3.39533 12.667 4.5V9.342"
      stroke="#959595"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M6.77233 12.0087H6.07033C5.29566 12.0087 4.66699 11.3807 4.66699 10.6053V9.26867C4.66699 8.844 5.01099 8.5 5.43566 8.5H7.40699C7.83166 8.5 8.17566 8.844 8.17566 9.26867V10.6053C8.17566 11.3807 7.54766 12.0087 6.77233 12.0087Z"
      stroke="#959595"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M4.02634 13.7002L3.33301 14.5002"
      stroke="#959595"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M12.667 14.5002L11.9736 13.7002"
      stroke="#959595"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg></div>
  )
}

export default Essential